export const UPDATE_BOARD = "UPDATED_BOARD";
export const SWITCH_PLAYER = "SWITCH_PLAYER";
export const SET_LEVEL = "SET_LEVEL";
export const SET_WINNER = "SET_WINNER";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_PLAYER_COLOR = "SET_PLAYER_COLOR";
export const SET_PLAY_ORDER = "SET_PLAY_ORDER";
export const SET_OPEN_PLAY_ORDER_DIALOG = "SET_OPEN_PLAY_ORDER_DIALOG";